import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "report-section keys" }
const _hoisted_2 = { class: "table" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("thead", { class: "thead-dark" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { width: "20%" }, "Location"),
    /*#__PURE__*/_createElementVNode("th", { width: "15%" }, "Type"),
    /*#__PURE__*/_createElementVNode("th", { width: "15%" }, "Check In"),
    /*#__PURE__*/_createElementVNode("th", { width: "15%" }, "Check Out"),
    /*#__PURE__*/_createElementVNode("th", { width: "10%" }, "Code"),
    /*#__PURE__*/_createElementVNode("th", { width: "20%" }, "Notes"),
    /*#__PURE__*/_createElementVNode("th", { width: "5%" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Actions")
    ])
  ])
], -1)
const _hoisted_4 = ["onUpdate:modelValue", "onChange"]
const _hoisted_5 = ["onUpdate:modelValue", "onChange"]
const _hoisted_6 = ["onUpdate:modelValue", "onChange"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["onUpdate:modelValue", "onChange"]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = ["onUpdate:modelValue", "onChange"]
const _hoisted_11 = ["onUpdate:modelValue", "onChange"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1)

import { computed, inject, ref } from 'vue';
import { useStore } from 'vuex';
import _ from 'lodash';
import { Report, Key } from '@/models';
import Photos from '@/components/photo/Photos.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Keys',
  setup(__props) {

const store = useStore();
const report = computed((): Report => store.getters['reports/current']);
const actProperty: any = inject('actProperty');
// Converting @Action to arrow functions
const setReportDeep = (payload: { path: string; data: any }): Promise<any> => {
  return store.dispatch('reports/setReportDeep', payload);
};
const keys = computed({
  get: () => report.value.keys,
  set: (data: Key[]) => {
    store.dispatch('reports/setReportDeep', { path: 'keys', data });
  },
});

const isCheckOut = () => {
  return report.value.type == 'checkout';
};

const addNewKey = () => {
  keys.value = keys.value.concat([new Key()]);
};

const removeKey = (index: number) => {
  actProperty.confirmPrompt()
      .then(() => keys.value = actProperty.removeItemByIndex(keys.value, index));
};
const editKey = (key:Key,index:Number) => {
 setReportDeep({
    path: `keys[${index}]`,
    data:key
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(keys.value, (key, $index) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: key._uuid
          }, [
            _createElementVNode("td", null, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": ($event: any) => ((key.name) = $event),
                class: "form-control form-control-sm",
                size: "10",
                onChange: ($event: any) => (editKey(key,$index))
              }, null, 40, _hoisted_4), [
                [
                  _vModelText,
                  key.name,
                  void 0,
                  { lazy: true }
                ]
              ])
            ]),
            _createElementVNode("td", null, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": ($event: any) => ((key.type) = $event),
                class: "form-control form-control-sm",
                size: "10",
                onChange: ($event: any) => (editKey(key,$index))
              }, null, 40, _hoisted_5), [
                [
                  _vModelText,
                  key.type,
                  void 0,
                  { lazy: true }
                ]
              ])
            ]),
            _createElementVNode("td", null, [
              _withDirectives(_createElementVNode("input", {
                type: "number",
                "onUpdate:modelValue": ($event: any) => ((key.qty.in) = $event),
                class: "form-control form-control-sm",
                min: "0",
                size: "1",
                onChange: ($event: any) => (editKey(key,$index))
              }, null, 40, _hoisted_6), [
                [
                  _vModelText,
                  key.qty.in,
                  void 0,
                  {
                    number: true,
                    lazy: true
                  }
                ]
              ]),
              (_openBlock(), _createBlock(Photos, {
                key: `key${key._uuid}in${key.photos.in.length}`,
                photos: key.photos.in,
                path: `keys[${$index}].photos.in`
              }, null, 8, ["photos", "path"]))
            ]),
            (isCheckOut())
              ? (_openBlock(), _createElementBlock("td", _hoisted_7, [
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    "onUpdate:modelValue": ($event: any) => ((key.qty.out) = $event),
                    class: "form-control form-control-sm",
                    min: "0",
                    size: "1",
                    onChange: ($event: any) => (editKey(key,$index))
                  }, null, 40, _hoisted_8), [
                    [
                      _vModelText,
                      key.qty.out,
                      void 0,
                      {
                        number: true,
                        lazy: true
                      }
                    ]
                  ]),
                  (_openBlock(), _createBlock(Photos, {
                    key: `key${key._uuid}out${key.photos.out.length}`,
                    photos: key.photos.out,
                    path: `keys[${$index}].photos.out`
                  }, null, 8, ["photos", "path"]))
                ]))
              : (_openBlock(), _createElementBlock("td", _hoisted_9)),
            _createElementVNode("td", null, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": ($event: any) => ((key.code) = $event),
                class: "form-control form-control-sm",
                size: "4",
                onChange: ($event: any) => (editKey(key,$index))
              }, null, 40, _hoisted_10), [
                [
                  _vModelText,
                  key.code,
                  void 0,
                  { lazy: true }
                ]
              ])
            ]),
            _createElementVNode("td", null, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": ($event: any) => ((key.notes) = $event),
                class: "form-control form-control-sm",
                onChange: ($event: any) => (editKey(key,$index))
              }, null, 40, _hoisted_11), [
                [
                  _vModelText,
                  key.notes,
                  void 0,
                  { lazy: true }
                ]
              ])
            ]),
            _createElementVNode("td", null, [
              _createElementVNode("button", {
                class: "btn btn-sm btn-outline-danger",
                onClick: ($event: any) => (removeKey($index)),
                tabindex: "-1"
              }, _hoisted_14, 8, _hoisted_12)
            ])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("button", {
      class: "btn btn-primary",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (addNewKey()))
    }, [
      _hoisted_15,
      _createTextVNode(" Key ")
    ])
  ]))
}
}

})